import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { CatHeading } from '@blocks-react/components/Heading';
import { TextHighlight } from '../../common/text-highlight';
import { getFamilyName } from './utils';
import { getProductFamily } from '../utils';
import { listProps, MyEquipmentSearchResultsProps } from '../types';
import styles from './MyEquipmentSearchResults.module.scss';

export const MyEquipmentSearchResults = ({
  list,
  onSelectListItem,
  searchTerm,
  limit,
  serialPrefixLabel = ''
}: MyEquipmentSearchResultsProps) => {
  const getListItems = (lists: listProps[]) => {
    return lists.map((item: listProps, index: number) => {
      const familyName = getFamilyName(
        item.model,
        item?.name ?? item?.equipmentFamily
      );
      const trainCaseEquipmentFamily: string = getProductFamily(
        familyName ?? ''
      );

      return index < limit ? (
        <CatListItem
          key={item.productId ?? item.partNumber}
          value={`${item.model} ${item.equipmentFamily}`}
          onBlSelect={() => onSelectListItem(item)}
        >
          <div className={`${styles['list-details']} d-flex`}>
            <figure className="m-0 align-top d-inline-block">
              <img src={item.imageUrl ?? item.imageURL} alt="" />
            </figure>
            <div
              className={`ms-2 d-inline-block align-content-center text-start`}
            >
              <CatHeading variant="title-sm">
                <TextHighlight
                  text={`${item.model} ${trainCaseEquipmentFamily}`}
                  textToHighlight={searchTerm}
                  isEscape
                />
              </CatHeading>
              {item.serialNumber && (
                <CatHeading variant="body">
                  <TextHighlight
                    text={`(${item.serialNumber} ${serialPrefixLabel})`}
                    textToHighlight={searchTerm}
                    isEscape
                  />
                </CatHeading>
              )}
            </div>
          </div>
        </CatListItem>
      ) : null;
    });
  };

  return <CatList aria-live="polite">{getListItems(list)}</CatList>;
};
